import DOMPurify from 'dompurify';

const ALLOWED_IFRAME_HOSTS = ['www.linkedin.com', 'linkedin.com'];

DOMPurify.addHook('uponSanitizeElement', (node, data) => {
  if (data.tagName !== 'iframe') return;
  let host = '';
  try { host = new URL(node.getAttribute('src') || '', window.location.origin).hostname; } catch { host = ''; }
  if (!ALLOWED_IFRAME_HOSTS.includes(host)) node.parentNode?.removeChild(node);
});

export const sanitizeEmbed = (html) =>
  DOMPurify.sanitize(html || '', {
    ADD_TAGS: ['iframe'],
    ADD_ATTR: ['allowfullscreen', 'frameborder', 'scrolling', 'allow', 'loading', 'title', 'height', 'width'],
    FORBID_TAGS: ['script', 'style'],
    FORBID_ATTR: ['onerror', 'onload'],
  });
